/* tslint:disable */
/* eslint-disable */

/**
 * 0 = NotReceived
 * 
 * 1 = Received
 * 
 * 2 = Failed
 * 
 * 3 = Passed
 */
export enum WorkOrderComponentStatus {
  NotReceived = 0,
  Received = 1,
  Failed = 2,
  Passed = 3
}
